import { FilterGroup, FilterGroupChannel } from '../types/channels-search';
import {
  Channel,
  ChannelGenreGroupType,
  ChannelsGroup,
  GenreGroupType,
} from '../types/landing-page';

export function getAllChannels(channelsGroups: ChannelsGroup[] | FilterGroup[]) {
  let allChannels: Channel[] | FilterGroupChannel[] = [];
  channelsGroups.forEach((group: ChannelsGroup | FilterGroup) => {
    allChannels = [...allChannels, ...group.channels];
  });
  return allChannels;
}

export function getAllChannelsMap(channelsGroup: ChannelsGroup[] | FilterGroup[]) {
  const allChannels = getAllChannels(channelsGroup);
  return allChannels.reduce<Record<string, Channel | FilterGroupChannel>>((acc, channel) => {
    acc[channel.name] = channel;
    return acc;
  }, {});
}

export function getChannelGenreGroupsWithChannelInfo(
  fromGenreGroups: GenreGroupType[],
  channelsMap: Record<string, Channel | FilterGroupChannel>,
) {
  const channelGenreGroups: Record<string, ChannelGenreGroupType[]> = {};
  fromGenreGroups.forEach(genreGroup => {
    const genreGroupWithAddedDetails: Channel[] & FilterGroupChannel[] = [];
    genreGroup.channels.forEach(channel => {
      if (channelsMap[channel.name]) {
        genreGroupWithAddedDetails.push(channelsMap[channel.name]);
      }
    });
    if (genreGroupWithAddedDetails.length > 0) {
      channelGenreGroups[genreGroup.title] = [{ channels: genreGroupWithAddedDetails }];
    }
  });

  return channelGenreGroups;
}
